import { Component, OnInit } from '@angular/core';


declare var $: any;

@Component({
	selector: 'app-documentation-layout',
	templateUrl: './documentation-layout.component.html',
	styleUrls: ['./documentation-layout.component.scss']
})
export class DocumentationLayoutComponent implements OnInit {
	
	title_page: any = '';

	products = [
		{
			name: 'QH Organizaciones',
			url: 'home',
			image: '/assets/img/demo.png'
		}
	];
	
	constructor(
	) {
	}
	
	ngOnInit() {
	}
	
	ngAfterViewInit(): void {
		$(function() {
			$('.toogle_dropdown').on('click', function(this: any) {
				$(this).next('.dropdown').slideToggle();
			});

			$('.toogle_dropdown_a').on('click', function(this: any) {
				$('.dropdown').slideUp()
			});
			
			$(document).on('click', function(e: any) { 
				var target = e.target; 
				if (!$(target).is('.toogle_dropdown') && !$(target).parents().is('.toogle_dropdown')) {
					$('.dropdown').slideUp()
				}
			});
			
			$('.content_header-space').css('padding-top', `${$('.header__menu').outerHeight()}px`);
			
			$('.btn_a-sidebar').on('click', function() {
				$('.bg__sidebar_left').fadeOut();
				$('.sidebar_left').removeClass('active');
			});
		});
		
		$('.btn__sidebar').on('click', function() {
			// console.log('click');
			$('.bg__sidebar_left').fadeToggle();
			$('.sidebar_left').toggleClass('active');
		});
	}
	
}
	